import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Station} from '../models/station.model';
import {map} from 'rxjs/operators';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScienceApiService {

  private url =  environment.ScienceApi; //'https://api.agric.wa.gov.au/v2/science/';
  private apiKey = environment.ScienceApiKey; //'NWw4nM3KOW8Y8wwJY3Nn6J3HCzIdnVg8';

  constructor(private http: HttpClient) {
  }

  public getSoilWater(startDate: string, endDate: string, soil: string, stationCode: string, evap: any) {
    const query = '?stationCode=' + stationCode
      + '&api_key=' + this.apiKey
      + '&startDate=' + startDate
      + '&endDate=' + endDate
      + '&soilType=' + soil
      + '&faoInitialisationDays=' + evap.initDays
      + '&faoInitialisationCropCoefficient=' + evap.initCoef
      + '&faoDevelopmentDays=' + evap.devDays
      + '&faoDevelopmentCropCoefficient=' + evap.devCoef
      + '&faoMidSeasonDays=' + evap.midDays
      + '&faoMidSeasonCropCoefficient=' + evap.midCoef
      + '&faoLateSeasonDays=' + evap.lateDays
      + '&faoLateSeasonCropCoefficient=' + evap.lateCoef
      + '&faoBreakOfSeason3Days25April=' + evap.bos1
      + '&faoBreakOfSeason3Days5June=' + evap.bos2;
    return this.http.get<any>(this.url + 'soilwater' + query);
  }

  public getStationList(): Observable<any> {
    return this.http.get<any>(this.url + 'stations' + '?api_key=' + this.apiKey)

  }

}
